import { __ } from './TranslationService';

export const getPhoneNumber = () => __('MobileWebsite helpline', 'dreamlines').replace(/ /g, '');
export const getEmailAddress = () => __('info@dreamlines.de', 'dreamlines');
